<template>
    <div class="modal warning fade" :class="{ 'is-open': open }">
        <div class="modal-dialog modal-sm">
            <div class="modal-content">
                <div class="modal-body">
                    <div class="warning">
                        <img width="48" alt=""
                            :src="`${BaseUrl}assets/common/warning.png`"
                            :srcset="`${BaseUrl}assets/common/warning@2x.png`">
                        <h4 class="text pt-3 mb-0">
                            <slot name="title"></slot>
                        </h4>
                        <span class="text pt-3">
                            <slot name="content"></slot>
                        </span>
                    </div>
                    <div class="action text-right">
                        <a @click="$emit('close')" class="btn btn-default">取消</a>
                        <a @click="$emit('confirm')" class="btn btn-primary">確定</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'ConfirmModal',
    computed: {
        ...mapGetters(['BaseUrl'])
    },
    data() {
        return {
        }
    },
    props: {
        open: {
            type: Boolean,
            default: false
        },
    },
}
</script>